module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/380.21a193cf.png";